import store from 'Store'

export default {
  inserted(el, binding) {
    const user = store.state.user.currentUser
    const comment = document.createComment(' ')
    const accessType = binding.arg?.toUpperCase()
    const editorAccess = binding.modifiers.editor

    if (accessType && accessType !== user.type) {
      if (el.parentNode) el.parentNode.replaceChild(comment, el)
    } else if (editorAccess && editorAccess !== user.is_editor) {
      if (el.parentNode) el.parentNode.replaceChild(comment, el)
    }
  },
}
